import { render } from "./cross.vue?vue&type=template&id=140225a8"
import script from "./cross.vue?vue&type=script&lang=js"
export * from "./cross.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__